import { render, staticRenderFns } from "./update_field.vue?vue&type=template&id=4f54a3d6&scoped=true"
import script from "./update_field.vue?vue&type=script&lang=js"
export * from "./update_field.vue?vue&type=script&lang=js"
import style0 from "./update_field.vue?vue&type=style&index=0&id=4f54a3d6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f54a3d6",
  null
  
)

export default component.exports